module.exports = __webpack_public_path__ + "static/img/a10.6e70e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/attestation/a10.png
// module id = aLvp
// module chunks = 0